import createComponent from '@carvana/merch-components/createComponent';
import cx from 'classnames';

export const TitleWrapper = createComponent('div', {
  className:
    'flex items-center text-center text-[calc(14px+(16-14)*((100vw-300px)/(1600-300)))] uppercase'
});

export const Title = createComponent('h2', {
  className: cx(
    'text-[24px] font-bold leading-[28px] sm:tl-header-xl md:tl-header-xxl',
    'w-[200px] sm:w-[410px]',
    'mb-8 mt-16 text-blue-6'
  )
});

export const HeaderWrapper = createComponent('div', {
  className: 'text-center text-blue-6'
});

export const Header = createComponent('h1', {
  className: cx(
    'text-[calc(40px+(70-40)*((100vw-300px)/(1600-300)))] font-bold uppercase leading-[90%]',
    'mx-auto mb-auto mt-0',
    'max-w-[85%] sm:max-w-[70%] lg:max-w-[60%]'
  )
});

export const HeaderSubText = createComponent('p', {
  className: cx(
    'w-[300px] sm:w-[500px] md:w-[700px]',
    'mx-auto my-24 sm:my-[34px] md:my-40',
    'tl-body-s sm:tl-body-l md:text-[24px]'
  )
});

export const HeaderSubTextBold = createComponent('p', {
  className:
    'my-12 !font-extrabold uppercase text-blue-6 tl-body-s sm:tl-body-l md:text-[24px]'
});
